import React from "react";
import ArrowIcon from "../../../../assets/svg/icons/common/arrow";
import Pagination from "../../../../components/Pagination/Pagination";
import Row from "./Row";
import useCommonStore from "../../../../stores/common";
import useMerchantStore from "../../../../stores/merchant";
import useDomainStore from "../../../../stores/domain";
import SkeletonLoader from "../../../../components/skeleton-loader";
import SkeletonRow from "../../../../components/skeleton-loader/table/row";
import rowsToFill from "../../../../utils/rows-to-fill";
import styles from "../../Style.module.scss";
import MerchantCard from "./MerchantCard";

function Listing() {
  const { isKurvDomain } = useDomainStore();
  const showDetails = useCommonStore((state) => state.showDetails);
  const setShowDetails = useCommonStore((state) => state.setShowDetails);
  const merchantList = useMerchantStore((state) => state.merchantList);
  const merchantListLoading = useMerchantStore(
    (state) => state.merchantListLoading,
  );
  const merchantFilterSearchQuery = useMerchantStore(
    (state) => state.merchantFilterSearchQuery,
  );
  const setMerchantFilterSearchQuery = useMerchantStore(
    (state) => state.setMerchantFilterSearchQuery,
  );
  const pageCount = useMerchantStore((state) => state.pageCount);
  const totalItems = useMerchantStore((state) => state.totalItems);
  const itemsPerPage = useMerchantStore((state) => state.itemsPerPage);
  const setActiveAppId = useMerchantStore((state) => state.setActiveAppId);
  const activeAppId = useMerchantStore((state) => state.activeAppId);

  const handleMobileCardClick = (appId) => {
    setActiveAppId(appId);
    setShowDetails(true);
  };

  const onSortClick = (field) => {
    setMerchantFilterSearchQuery({
      sortBy: field,
      sortValue:
        merchantFilterSearchQuery.sortValue == "DESC" ? "ASC" : "DESC",
    });
  };

  return (
    <>
      <table className={`${styles.desktop_table} ${isKurvDomain ? styles.kurv_theme : ""}`}>
        <thead>
          <tr>
            <th></th>
            <th
              className={styles.sortable_th}
              onClick={() => onSortClick("field_dba")}
            >
              DBA
              {merchantFilterSearchQuery.sortBy == "field_dba" && (
                <button
                  className={`${styles.sorting_button} ${merchantFilterSearchQuery.sortValue == "DESC" ? "" : styles.asc}`}
                >
                  <ArrowIcon />
                </button>
              )}
            </th>
            <th>MID</th>
            <th
              className={styles.sortable_th}
              onClick={() => onSortClick("progression_id")}
            >
              STATUS
              {merchantFilterSearchQuery.sortBy == "progression_id" && (
                <button
                  className={`${styles.sorting_button} ${merchantFilterSearchQuery.sortValue == "DESC" ? "" : styles.asc}`}
                >
                  <ArrowIcon />
                </button>
              )}
            </th>
            {!showDetails && <th>VOLUME CAP</th>}
            <th>VOLUME USED</th>
            <th>VOLUME MTD</th>
            {!showDetails && <th>MOM CHANGE</th>}
            {!showDetails && (
              <th
                className={styles.sortable_th}
                onClick={() => onSortClick("approved_at")}
              >
                DATE APPROVED
                {merchantFilterSearchQuery.sortBy == "approved_at" && (
                  <button
                    className={`${styles.sorting_button} ${merchantFilterSearchQuery.sortValue == "DESC" ? "" : styles.asc}`}
                  >
                    <ArrowIcon />
                  </button>
                )}
              </th>
            )}
            <th>ALERT</th>
          </tr>
        </thead>
        <tbody>
          {merchantListLoading &&
            Array.from({ length: rowsToFill(window.innerHeight) }).map(
              (_, index) => (
                <SkeletonRow
                  key={index}
                  columnLength={8}
                  withBlankFirstRow
                />
              ),
            )}

          {!merchantListLoading &&
            merchantList.map((app, index) => {
              return <Row key={index} app={app} />;
            })}
        </tbody>
      </table>

      <div className={styles.mobile_cards_container}>
        {merchantListLoading &&
          Array.from({ length: rowsToFill(window.innerHeight) }).map(
            (_, index) => (
              <div key={index} className={styles.skeleton_mobile_card}>
                <div className={styles.mobile_card_left} />
                <div className={styles.mobile_card_center}>
                  <SkeletonLoader
                    variant="text"
                    width="80%"
                    height="14px"
                    style={{ minHeight: "14px" }}
                  />
                </div>
                <div className={styles.mobile_card_right}>
                  <SkeletonLoader
                    variant="circular"
                    width="16px"
                    height="16px"
                  />
                </div>
              </div>
            ),
          )}

        {!merchantListLoading &&
          merchantList.map((app, index) => (
            <MerchantCard
              key={app.id ?? index}
              app={app}
              onClick={() => handleMobileCardClick(app.id)}
              isSelected={activeAppId === app.id}
            />
          ))}
      </div>

      {merchantList?.length < 1 && !merchantListLoading && (
        <h6 className={styles.no_data_found}>No data to display</h6>
      )}

      {(merchantList?.length > 0 || merchantFilterSearchQuery.page > 1) && (
        <div className={styles.pagination_container}>
          <Pagination
            pageCount={pageCount}
            currentPage={merchantFilterSearchQuery.page - 1}
            onPageChange={({ selected }) => {
              setMerchantFilterSearchQuery({
                page: selected + 1,
              });
            }}
            totalItems={totalItems}
            itemsPerPage={itemsPerPage}
          />
        </div>
      )}
    </>
  );
}

export default Listing;
